module.exports = __webpack_public_path__ + "img/icon.68e0e422.png";